'use strict'

var App = require('app')
var _ = require('lodash')

var PageComponent = require('src/components/page-view')
var PageBodyComponent = require('src/components/page-body-view')
var ListComponent = require('src/components/list-view')

/**
 * Global page layout
 * -----------------------------------------------------------------------------
 */
var Layout = PageComponent.Layout.extend({
  className: 'page page__clients'
})

module.exports.Layout = Layout

/**
 * Page body layout
 * -----------------------------------------------------------------------------
 */
var BodyLayoutView = PageBodyComponent.Layout.extend({})

module.exports.BodyLayout = BodyLayoutView

/**
 * List view
 * -----------------------------------------------------------------------------
 * List Component which supports paginating and bulk edit
 */
var ListView = ListComponent.ListView.extend({})

module.exports.ListView = ListView

/**
 * List item view
 * -----------------------------------------------------------------------------
 */
var ListItem = ListComponent.ItemView.extend({
  templateContext: function () {
    var self = this
    return {
      getListColumns: function () {
        return self.options.columns
      },
      getHideClasses: App.TemplateHelpers.getHideClasses(self.options),             
      getColumnField: function (field) {
        var value = _.get(this, field)

        function unicodeEscape(str) {
          return str.replace(/[\s\S]/g, function (escape) {
            return '\\u' + ('0000' + escape.charCodeAt().toString(16)).slice(-4);
          });
        }

        switch (field) {
          case 'name':
            var name = ''
            name += _.get(this, 'name')
            if (_.get(this, 'warehouse')) name += ' - warehouse'
            return name
          case 'nodes':
            return _.get(this, 'status.devices.total') || 0
          case 'createdAt':
            return App.TemplateHelpers.formatTime(value)
          default:
            return value
        }
      }
    }
  }
})
module.exports.ListItem = ListItem



// WEBPACK FOOTER //
// ./js/modules/page-clients/list/view.js